import { render, staticRenderFns } from "./CommentPopup.vue?vue&type=template&id=690fad72&"
import script from "./CommentPopup.vue?vue&type=script&lang=js&"
export * from "./CommentPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports